<template>
    <v-card
        :style="style"
        :ripple="false"
        flat
        :to="{ name: 'quest-details', params: { id: quest.id } }"
        width="100%"
    >
        <v-card-title class="pb-0">
            <v-chip :color="color" label small class="text-uppercase text-overline font-weight-medium">{{ label }}</v-chip>

            <slot name="additionalLabel" />

            <v-spacer />

            <v-menu v-model="menuModel" v-if="showMenu" fixed bottom left>
                <template v-slot:activator="{ on }">
                    <v-btn icon @click.prevent="on.click" color="primary">
                        <v-icon>fas fa-ellipsis-v</v-icon>
                    </v-btn>
                </template>

                <quest-menu-list
                    v-if="$vuetify.breakpoint.mdAndUp"
                    :quest="quest"
                    @display-quest-preview-dialog="questPreviewDialog = true"
                    @display-delete-dialog="deleteDialog = true"
                    @hide-menu="menuModel = false"
                />

                <v-bottom-sheet v-model="menuModel" persistent v-else>
                    <quest-menu-list
                        text-center
                        :quest="quest"
                        @display-quest-preview-dialog="questPreviewDialog = true"
                        @display-delete-dialog="deleteDialog = true"
                        @hide-menu="menuModel = false"
                    />
                </v-bottom-sheet>
            </v-menu>
        </v-card-title>

        <v-card-title class="pt-1 pb-0 text-h5">{{ quest.name }}</v-card-title>

        <v-card-text>
            <v-row>
                <v-col :cols="quest.pointsApplyStrategy === 'scan' ? 10 : 12">
                    <p class="mb-0" v-if="displayStartDate">{{ $t('Starts') }}: {{ getStartDate(quest) }}</p>

                    <p class="mb-0" v-if="displayEndDate">{{ $t('Ended') }}: {{ getEndDate(quest) }}</p>

                    <slot name="additionalInfo" v-if="!hideParticipantsInfo">
                        <span>{{ questParticipantsLabel }}: {{ quest.participantsCount }}</span>
                    </slot>
                </v-col>

                <v-col v-if="quest.pointsApplyStrategy === 'scan'" cols="2" class="d-flex justify-end align-end">
                    <v-btn :disabled="disableQrButton" icon color="primary" @click.prevent="displayQrOverlay = true">
                        <v-icon>fas fa-qrcode</v-icon>
                    </v-btn>

                    <qr-code-overlay v-if="displayQrOverlay" v-model="displayQrOverlay" :quest="quest" />
                </v-col>
            </v-row>
        </v-card-text>

        <quest-delete-dialog v-model="deleteDialog" :quests="[quest.id]" @quests-deleted="onQuestDeleted" />

        <quest-preview-dialog v-model="questPreviewDialog" :questId="quest.id" show-tips-view />
    </v-card>
</template>

<style>
.participants-amount-preview {
    vertical-align: middle;
}
</style>

<script>
import moment from 'moment';
import QrCodeOverlay from './QrCodeOverlay';
import QuestMenuList from './QuestMenuList';
import QuestDeleteDialog from './QuestDeleteDialog';
import QuestPreviewDialog from './QuestPreviewDialog';

export default {
    components: {
        QuestMenuList,
        QrCodeOverlay,
        QuestDeleteDialog,
        QuestPreviewDialog,
    },
    props: {
        quest: null,
        quests: {
            type: Array,
        },
        color: null,
        label: null,
        displayStartDate: {
            type: Boolean,
            default: true,
        },
        questParticipantsLabel: String,
        displayEndDate: Boolean,
        disableQrButton: Boolean,
        showMenu: Boolean,
        hideParticipantsInfo: Boolean,
    },
    data() {
        return {
            displayQrOverlay: false,
            menuModel: null,
            deleteDialog: false,
            questPreviewDialog: false,
        };
    },
    computed: {
        style() {
            return {
                'border-left': '4px solid var(--v-' + this.color + '-base)',
            };
        },
    },
    methods: {
        getStartDate(quest) {
            return moment(quest.startDate.date).format('DD.MM.YYYY, HH:mm') + ' ' + this.$t("O'clock");
        },
        getEndDate(quest) {
            return moment(quest.endDate.date).format('DD.MM.YYYY, HH:mm') + ' ' + this.$t("O'clock");
        },
        onQuestDeleted(ids) {
            this.$emit('quests-deleted', ids);
            this.menuModel = false;
        },
    },
};
</script>
